import React from 'react';
import { shallowEqual } from 'react-redux';
import NotificationsIcon from '@mui/icons-material/Notifications';
import { Badge } from '@mui/material';

import { useAppMonitor } from '../../../monitor';
import {
  getNotificationCenterRelevantSnackbars,
  getWorstSeverityFromSnackbars,
} from '../../../store/selectors/notificationSelectors';
import { leftSidebarSet } from '../../../store/slices/panelDataSlice';
import { useAppDispatch, useAppSelector } from '../../hooks';
import { ToolbarIconButton } from '../top/ToolbarIconButton';

export function NotificationsButton() {
  const monitor = useAppMonitor();
  const dispatch = useAppDispatch();

  const { notificationCount, worstSeverity } = useAppSelector(
    (state) => {
      const snackbars = getNotificationCenterRelevantSnackbars(state);
      return { notificationCount: snackbars.length, worstSeverity: getWorstSeverityFromSnackbars(snackbars) };
    },
    { equalityFn: shallowEqual },
  );

  const panelOpen = useAppSelector((state) => state.panelData.leftSidebar === 'notifications');

  return (
    <ToolbarIconButton
      title="Notifications"
      icon={
        <Badge invisible={notificationCount === 0} badgeContent={notificationCount} color={worstSeverity}>
          <NotificationsIcon />
        </Badge>
      }
      onClick={() => {
        dispatch(leftSidebarSet(panelOpen ? 'open' : 'notifications'));
        monitor.recordInteraction('Notifications button clicked');
      }}
    />
  );
}
